import {ReactNode} from 'react';

import './Avatar.scss';

interface IProps {
  imageSource: string;
  Icon?: ReactNode;
}

const Avatar = ({imageSource, Icon}: IProps) => {
  return (
    <div className="avatar">
      {imageSource && <img data-testid="avatar-image" src={imageSource} alt="brewery" />}
      {!imageSource && <span data-testid="icon-avatar">{Icon}</span>}
    </div>
  );
};

export default Avatar;
